export default "__VITE_ASSET__ONJEX3wv__"